export default () => ({
  newRecommendation: {
    calibrateRecommendation: null,
    calibrateType: null,
    firm: 1,
    isInactive: false,
    sort: 0,
    vehicleMake: null,
    vehicleMakeName: '',
    recommendation: '',
    recommendationText: null
  },
  recommendations: [],
  recommendation: null,
  criteriaChanged: false,
  step: 1,
  visitedStep: 1,
  translations: [],
  bmsRepairs: [],
  bmsXml: null
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/state.js